import { Box } from "@chakra-ui/react";
import Head from "next/head";
import { useEffect } from "react";
import InstallerReviewsCard from "src/components/InstallerReviewsCard";
import Breadcrumbs from "../../components/InstallerBreadcrumbs";
import InstallerCard from "../../components/InstallerCard";
import { LocationCard } from "../../components/LocationCard";
import * as ga from "../../lib/ga";
import SummaryCard from "src/components/SummaryCard";
import getInstallerBySlug from "src/lib/getInstallerBySlug";
import getInstallers from "src/lib/getInstallers";
import { ActionType, sendEvent } from "src/lib/sendEvent";

export const getStaticPaths = async () => {
  const data = await getInstallers();

  const paths = data.map((installer) => {
    return {
      params: {
        slug: installer.slug,
      },
    };
  });

  return {
    paths,
    fallback: false,
  };
};

export async function getStaticProps(context) {
  const data = await getInstallerBySlug(context.params.slug);

  // If no installer is found, return not found or redirect to 404.
  if (!data) {
    return {
      notFound: true, // This will automatically render your custom 404 page.
    };
  }

  // Note: TS is complaining because the name is not specified. There's probably a way to fix this by using the prisma types better in getInstallerBySlug.tsx.
  // @ts-ignore
  const companyName = data.name;

  return {
    props: {
      pageHeader: {
        title: `${companyName} | Solar Installer | Reviews`,
        description: `Read reviews from real people who've had a solar installation by ${companyName}. See what they have to say about their experience with ${companyName}.`,
      },
      installer: data,
    },
    revalidate: 60,
  };
}

function Installer({ installer, pageHeader }) {
  useEffect(() => {
    ga.event({
      action: "installer_page_view",
      params: {
        name: installer.name,
      },
    });
    sendEvent(ActionType.PAGE_VIEW, installer.voltwise_id);
  }, [installer]);

  const { name, summary } = installer;

  return (
    <>
      <Head>
        <title>{pageHeader.title}</title>
      </Head>
      <Box maxW={"800px"} ml={"auto"} mr={"auto"}>
        <Box>
          <Breadcrumbs name={name} />
        </Box>

        <InstallerCard {...installer} />
        {summary && <SummaryCard summary={summary} />}
        {installer.google_review_score && (
          <InstallerReviewsCard {...installer} />
        )}
        <LocationCard {...installer} />
      </Box>
    </>
  );
}

export default Installer;
